import { api } from "@/api/client";
import { convertToURLSearchParams, ServiceClient } from "@/util";
import { PaginatedSearch } from "@/types";
import { RecordStandardGroup } from "../record";

export type CertificateListView = {
  recordId: string;
  recordNumber: string;
  welderId: string;
  welderName: string;
  templateId: string;
  templateNumber: string;
  standard: RecordStandardGroup;
  result: string;
  process: string;
  pinned: boolean;
};

export type ExpirationsListView = {
  welderId: string;
  welderName: string;
  standard: string;
  contractorId: string;
  contractor: string;
  processName: string;
  processType: string;
  cfR192: string;
  cfR195: string;
  basic: string;
  basicNde: string;
  revoked: boolean;
  ineligible: boolean;
};

export interface CertificateFilters extends PaginatedSearch {
  favorite: boolean;
  welderId: string;
  projectId: string;
  contractorId: string;
  searchString: string;
}

export interface ExpirationsFilters extends PaginatedSearch {
  welderId?: string;
  contractorId?: string;
  searchString: string;
}

export function getCertificateList(filters: Partial<CertificateFilters>) {
  const params = convertToURLSearchParams(filters);
  return api.getPaginated<CertificateListView[]>(`williams/certificates?${params}`);
}

export function getExpirationList(filters: Partial<ExpirationsFilters>) {
  const params = convertToURLSearchParams(filters);
  return api.getPaginated<ExpirationsListView[]>(`williams/certificates/expirations?${params}`);
}

export function downloadCertificate(recordId: string) {
  ServiceClient.redirect(`williams/certificates/${recordId}`);
}

export function togglePinned(id: string) {
  return api.post(`williams/certificates/pin?id=${id}`);
}
